import { CurrencyPipe } from '@angular/common';
import { Component } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { FeesDetailsButtonComponent } from '../../fee-details/fee-details-button.component';
import { InstallmentsDropdownAbstract } from '../installments-dropdown.abstract';

@Component({
  selector: 'app-installments-dropdown-drawer',
  templateUrl: './installments-dropdown-drawer.component.html',
  styleUrls: [`../installments-dropdown/installments-dropdown.component.scss`],
  imports: [CurrencyPipe, MatSidenavModule, FeesDetailsButtonComponent],
})
export class InstallmentsDropdownDrawerComponent extends InstallmentsDropdownAbstract {}
